import { useState, useEffect } from 'react';
import { obtainCoupon } from 'mod/coupon/service';
import { useRouter } from 'next/router';
import { QUERY_COUPON_CODE, STATUS_INVALID, STATUS_OBTAINED } from 'mod/coupon/constant';
import { ICoupon, IObtainedCoupon } from 'mod/coupon/interface';

type IUrlCouponInstance = {
    coupon?: ICoupon;
    isLogin: boolean;
    couponLoaded: boolean;
};

export function useUrlCoupon(): IUrlCouponInstance {
    const { query } = useRouter();
    const [coupon, setCoupon] = useState<ICoupon>();
    const [isLogin, setIsLogin] = useState<boolean>(false);
    const [couponLoaded, setCouponLoaded] = useState<boolean>(false);

    const fetchData = async () => {
        const couponCode = query[QUERY_COUPON_CODE];

        if (typeof couponCode === 'string') {
            const { status, coupon } = await obtainCoupon(couponCode).catch(() => ({ status: STATUS_INVALID } as IObtainedCoupon));
            if (status !== STATUS_INVALID) {
                setCoupon(coupon);
                setIsLogin(status === STATUS_OBTAINED);
            }
        }
        setCouponLoaded(true);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return {
        coupon,
        isLogin,
        couponLoaded
    }
}